import { html } from 'lit';
import '../components/icon/element.js';
import { chatConfig } from '@beunity/lit-components/components/chat/lib/config.js';
// components/chat_list_item/element.js

import ChatListItem from '@beunity/lit-components/components/chat_list_item/element.js';

ChatListItem.renderMenu = chatId => {
  return html`<bu-chat-menu role="menu" .chatId=${chatId}></bu-chat-menu>`;
};

ChatListItem.prototype.renderUnsentMessagesIndicator = function () {
  return html`
    <div class="unsent-messages-indicator">
      <bu-icon name="circle-exclamation:solid"></bu-icon>
      <strong>${this.t('unsent_messages_note')}</strong>
    </div>
  `;
};

chatConfig.fileLayout = 'lg';
chatConfig.icons.new_message_indicator = 'chevron-down';
chatConfig.icons.retry = 'redo';
chatConfig.icons.dismiss = 'close';
chatConfig.icons.states.final_seen = 'check';
chatConfig.icons.form.exit_edit_mode = 'close';
chatConfig.menu.infoOn = true;
